import { createContext, useContext } from 'react';

export type ContextState = Record<string, any>;

export const DataGridContext = createContext<ContextState | null>(null);

export const useDataGridContext = <C extends ContextState>(): C => {
  const context = useContext(DataGridContext) as unknown as C | null;
  if (!context) {
    throw new Error('useDataGridContext must be used within a DataGridContextProvider');
  }
  return context;
};
